var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkedList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#feed34;}.cls-3{fill:#ff4a64;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    id: "verify"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 32,
    id: "bg",
    width: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.11,30,6.58,24.26V5.61a2.89,2.89,0,0,1,2.76-3H22.89a2.9,2.9,0,0,1,2.77,3V24.35Zm-7.53-6.9,7.54,4.57,7.54-4.49V5.61a.92.92,0,0,0-.77-1H9.34c-.41,0-.76.46-.76,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.52,20.72a1,1,0,0,1-.6-.2l-3-2.24a1,1,0,0,1-.2-1.4,1,1,0,0,1,1.4-.2l3,2.24a1,1,0,0,1-.6,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.52,20.72a1,1,0,0,1-.61-.21,1,1,0,0,1-.17-1.4l4.18-5.35A1,1,0,1,1,20.49,15l-4.18,5.34A1,1,0,0,1,15.52,20.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.58,3.61H22.66a2,2,0,0,1,2,2V9.86a0,0,0,0,1,0,0H7.58a0,0,0,0,1,0,0V5.61A2,2,0,0,1,9.58,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.66,10.86H6.58V5.61a3,3,0,0,1,3-3H22.66a3,3,0,0,1,3,3Zm-17.08-2H23.66V5.61a1,1,0,0,0-1-1H9.58a1,1,0,0,0-1,1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkedList);
export default __webpack_public_path__ + "static/media/marked_list.5e8eefd0dc2afa5b107363899f25cb2d.svg";
export { ForwardRef as ReactComponent };